export default "__VITE_ASSET__BrHTJkw5__"